import { v4 as uuidv4 } from 'uuid';
import store from "../../context/store/store";
import { UserDetails } from "../../models/model";
import { calldetail } from "../../models/callModel";
import { Types } from "../../context/action/action";
import _ from 'lodash';

var parser = require('xml-js');

export const adhocXmlParsing = (xml: any) => {
  let conferenceDetails = store.getState().conferenceDetails || [];
  try {
  var jsonData: any = parser.xml2json(xml, { compact: true, spaces: 4 });
  jsonData = JSON.parse(jsonData);
  if (xml.includes('removed')) {
    let userList: any = conferenceDetails.list || [];
    let confList: any = userList.userList || [];
    let users = jsonData["conference-info"]['users']['user'];
    let removeCall_Id = users["call-info"]['call-id']["_attributes"].id;
    let index: any = confList.findIndex((elem: any) => (elem.call_Id === removeCall_Id));

    if (index !== -1) {
      confList.splice(index, 1);
      userList.userList = confList;
      store.dispatch({
        type: Types.UPDATDE_CONFERENCE_LIST,
        payloads: {
          list:userList,
          checkConf: true,
          isNewCall:false
        }
      });
    }
  }
  else {
    
      let conference: any = {
        confid: jsonData["conference-info"]['_attributes'].confid,
        host_entity: jsonData["conference-info"]['host-info']['_attributes'].entity,
        host_confdisplayname: jsonData["conference-info"]['host-info']['_attributes'].confdisplayname,
        host_callid: jsonData["conference-info"]['host-info']['_attributes']['call-id'],
        userCount: jsonData["conference-info"]['users']['_attributes'].count
      };
      let userList: any = [];
      let users = jsonData["conference-info"]['users']['user'];
      users.forEach((element: any) => {
        let userData: any = {};
        userData.callcount = element["_attributes"].callcount;
        userData.entity = element["_attributes"].entity;
        userData.att_index = element["_attributes"].index;
        userData.type = element["_attributes"].type;

        userData.index = element["call-info"]["_attributes"].index;
        userData.call_Id = element["call-info"]['call-id']["_attributes"].id;
        userData.call_Status = element["call-info"]['call_status']["_attributes"].status;
        userData.from_Sipuri = element["call-info"]['from']["_attributes"].sipuri;
        userData.from_Tagid = element["call-info"]['from']["_attributes"].tagid;
        userData.to_Sipuri = element["call-info"]['to']["_attributes"].sipuri;
        userData.to_Tagid = element["call-info"]['to']["_attributes"].tagid;
        
        if(conferenceDetails.isNewCall) {
          let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
          let index: number = _.findIndex(currentCallList, { isCurrent: true });
          if (index !== -1) {
           let ext =  (currentCallList[index].bound === "out") ? currentCallList[index].to :currentCallList[index].from;
           conferenceDetails.isNewCall = ((element["_attributes"]?.entity).split('@')[0]).toString()===(ext).toString() ? false : conferenceDetails.isNewCall;
          }
        }
        userList.push(userData);
      });
      conference.userList = userList;
      store.dispatch({
        type: Types.UPDATDE_CONFERENCE_LIST,
        payloads: {
          list:conference,
          checkConf: true,
          isNewCall:conferenceDetails.isNewCall
        }
      });


      if (conferenceDetails.isConference) {

        let remoteVideo: any = document.getElementById("remoteVideo");
        let thissession = conferenceDetails.callDetails;
        let remoteStream = new MediaStream();
        var pc = thissession.sessionDescriptionHandler.peerConnection; // Gets remote tracks
        if (pc.getReceivers) {
          pc.getReceivers().forEach(function(receiver: any) {
            var track = receiver.track;
            if (track) { remoteStream.addTrack(track); }
          });
        } else { remoteStream = pc.getRemoteStreams()[0]; }
        remoteVideo.srcObject = remoteStream;
      }
    }
  }
  catch (e) { console.log("error is", e); }
};

export const adhocXmlFraming = (currentCallList: calldetail[], cur_Index: number) => {
  
  let confId = uuidv4();
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let orginator: any = loggedUserDetails.ext + "@" + loggedUserDetails.domain_name;
  let call_id: any = currentCallList[cur_Index].useragent;
  let call_Tags: any = call_id.session.dialogState;
  let xml = '<conference-info confid="' + confId + '" state="start">' +
        '<host-info call-id="' + call_Tags.callId + '" confdisplayname="unified meeting" entity="' + orginator + '"/>' +
        '<users count="1">' +
        '<user callcount="' + currentCallList.length + '" entity="' + orginator + '" index="0" type="host">';

  currentCallList.forEach((data: any, index: any) => {
    let element: any = data.useragent;
    let Tags = element.session.dialogState;

    let toUser = element.remoteIdentity.uri.raw.user + "@" + element.remoteIdentity.uri.raw.host;
    let fromUser = element.localIdentity.uri.raw.user + "@" + element.localIdentity.uri.raw.host;
    let fromTag = Tags.localTag;
    let toTag = Tags.remoteTag;

    if (data['bound'] === 'IN') {
      fromUser = element.remoteIdentity.uri.raw.user + "@" + element.remoteIdentity.uri.raw.host;
      toUser = element.localIdentity.uri.raw.user + "@" + element.localIdentity.uri.raw.host;
      fromTag = Tags.remoteTag;
      toTag = Tags.localTag;
    }

    xml += '<call-info index="' + index + '">' +
          '<call-id id="' + Tags.callId + '"/>' +
          '<call_status status="joining"/>' +
          '<display-text value="Team meeting"/>' +
          '<from sipuri="' + fromUser + ':5060" tagid="' + fromTag + '"/>' +
          '<to sipuri="' + toUser + ':5060" tagid="' + toTag + '"/>' +
          '</call-info>';
  });

  xml += '</user>' +
        '</users>' +
    '</conference-info>';
  
  return xml;
};

export const confRemoveParticipant = (removeParticipantData:any) => {
  let conferenceDetails = store.getState().conferenceDetails || [];
  let userList: any = conferenceDetails.list;

  let xml = '<conference-info confid="' + userList.confid + '" state="update">' +
    '<host-info call-id="' + userList.host_callid + '" confdisplayname="' +
    userList.host_confdisplayname + '" entity="' + userList.host_entity + '"/>' +
    '<users count="' + userList.userCount + '">';

  userList.userList.forEach((data: any, index: any) => {

    xml += '<user entity="' + data.entity + '" type="' + data.type + '" callcount="' +
      data.callcount + '" index="' + data.att_index + '">' +
      '<call-info index="' + data.index + '">' +
      '<call-id id="' + data.call_Id + '"/>';
    if (data.call_Id === removeParticipantData.call_Id) {
      xml += '<call_status status="removed"/>';
    }
    else {
      xml += '<call_status status="' + data.call_Status + '"/>';
    }
    xml += '<display-text value="Team meeting"/>' +
      '<from sipuri="' + data.from_Sipuri + '" tagid="' + data.from_Tagid + '"/>' +
      '<to sipuri="' + data.to_Sipuri + '" tagid="' + data.to_Tagid + '"/>' +
      '</call-info>' +
      '</user>';
  });

  xml += '</users>' +
    '</conference-info>';
  return xml;
};

export const mergeConf_Xml_Framing = (current_user:any) => {
  let conferenceDetails = store.getState().conferenceDetails || [];
  let userList: any = conferenceDetails.list;

  let xml = '<conference-info confid="' + userList.confid + '" state="update">' +
      '<host-info call-id="' + userList.host_callid +
      '" confdisplayname="' + userList.host_confdisplayname + '" entity="'
      + userList.host_entity + '"/>' +
      '<users count="' + userList.userCount + '">';

  let toUser = current_user.remoteIdentity.uri.raw.user + "@" + current_user.remoteIdentity.uri.raw.host;
  let fromUser = current_user.localIdentity.uri.raw.user + "@" + current_user.localIdentity.uri.raw.host;
  let Tags = current_user.session.dialogState;

  userList.userList.forEach((data: any, index: any) => {
    if (index === 0) {
      xml += '<user entity="' + data.entity + '" type="' + data.type +
          '" callcount="2" index="' + data.att_index + '">';
    }
    else {
      xml += '<user entity="' + data.entity + '" type="' + data.type +
          '" callcount="' + data.callcount + '" index="' + data.att_index + '">';
    }

    xml += '<call-info index="' + data.index + '">' +
        '<call-id id="' + data.call_Id + '"/>' +
        '<call_status status="' + data.call_Status + '"/>' +
        '<display-text value="Team meeting"/>' +
        '<from sipuri="' + data.from_Sipuri + '" tagid="' + data.from_Tagid + '"/>' +
        '<to sipuri="' + data.to_Sipuri + '" tagid="' + data.to_Tagid + '"/>' +
        '</call-info>';

    if (index === 0) {
      xml += '<call-info index="1">' +
          '<call-id id="' + Tags.callId + '"/>' +
          '<call_status status="joining"/>' +
          '<display-text value="Team meeting"/>' +
          '<from sipuri="' + fromUser + ':5060" tagid="' + Tags.localTag + '"/>' +
          '<to sipuri="' + toUser + ':5060" tagid="' + Tags.remoteTag + '"/>' +
          '</call-info>';
    }

    xml += '</user>';
  });

  xml += '</users>' +
      '</conference-info>';
  return xml;
};